import { request } from '@/store/client'

export const applyResetPassword = (token: string, password: string): Promise<any> => {
  return request({
    url: '/user/',
    method: 'patch',
    data: {
      token,
      password,
    },
  }).catch((error) => {
    if (error.response.status === 400) {
      throw new Error('PasswordHistory')
    }

    if (error.response.status === 409) {
      throw new Error('TokenNotFound')
    }

    if (error.response.status === 410) {
      throw new Error('TokenExpired')
    }

    throw error
  })
}
